module.exports = __webpack_public_path__ + "img/logos.ce6496e3.png";